// Ушли платить на страницу платёжки (владелец 16.10: «блок тарифа после оплаты подтягивается только после обновления
// страницы»). Перед уходом запоминаем, что было: баланс и тариф. Вернувшись в кабинет, по ним видно, применилась ли
// оплата, — до этого блок тарифа показывает «Обновляем данные оплаты…». sessionStorage: та же вкладка, переживает
// переход на платёжку и обратно; через 30 минут метка не действует. Запросов не делает.

const KEY = 'payment_pending'
const TTL_MS = 30 * 60_000

export interface PendingPayment {
	balanceBefore: number
	tariffBefore: string | null
	tariffWanted: string | null
	at: number
}

export function markPaymentStart(p: Omit<PendingPayment, 'at'>, now = Date.now()) {
	try {
		sessionStorage.setItem(KEY, JSON.stringify({ ...p, at: now }))
	} catch {
		// приватный режим — кабинет просто обновится без ожидания
	}
}

export function readPendingPayment(now = Date.now()): PendingPayment | null {
	try {
		const raw = sessionStorage.getItem(KEY)
		if (!raw) return null
		const p = JSON.parse(raw) as PendingPayment
		if (!p || typeof p.at !== 'number' || typeof p.balanceBefore !== 'number' || now - p.at > TTL_MS) {
			sessionStorage.removeItem(KEY)
			return null
		}
		return p
	} catch {
		return null
	}
}

export function clearPendingPayment() {
	try {
		sessionStorage.removeItem(KEY)
	} catch {
		// нечего чистить
	}
}

/** Оплата применилась: пришли токены или включился выбранный тариф. */
export function paymentApplied(p: PendingPayment, now: { balance: number; tariffId: string | null }): boolean {
	if (now.balance > p.balanceBefore) return true
	return !!p.tariffWanted && now.tariffId === p.tariffWanted && p.tariffBefore !== p.tariffWanted
}
